class DayCycle {

    constructor(scene, dayLength){
        this.scene = scene;
        this.dayLength = dayLength;
        this.shading = false;
        this.sunSprite = false;
        this.moonSprite = false;

        this.sceneheight = scene.cameras.main.displayHeight;
        this.scenewidth = scene.cameras.main.displayWidth;

        this.objectSettingPositionX = 150;
        this.objectRisingPositionX = this.scenewidth - 150;

    }

    initSun(sprite) {
        this.sunSprite = sprite;
        this.sunset(sprite);
    }

    initMoon(sprite) {
        this.moonSprite = sprite;
        this.moonrise(sprite);
    }

    initShading(sprites){
        this.shading = sprites;
    }

    sunrise(sprite){
        sprite.setPosition(this.objectRisingPositionX, sprite.y);

        this.sunTween = this.scene.tweens.add({
            targets: sprite,
            y: -250,
            duration: this.dayLength,
            onComplete: () => { this.sunset(sprite) },
            onCompleteScope: this
        });

        if(this.shading){
            this.shading.forEach((sprite) => {
                this.tweenTint(sprite.sprite, sprite.from, sprite.to, this.dayLength);
            });
        }
    }

    sunset(sprite){
        sprite.setPosition(this.objectSettingPositionX, sprite.y);

        this.sunTween = this.scene.tweens.add({
            targets: sprite,
            y: this.sceneheight,
            duration: this.dayLength,
            onComplete: () => { this.sunrise(sprite) },
            onCompleteScope: this
        });

        if(this.shading){
            this.shading.forEach((sprite) => {
                this.tweenTint(sprite.sprite, sprite.to, sprite.from, this.dayLength);
            });
        }
    }

    moonrise(sprite){
        sprite.setPosition(this.objectRisingPositionX, sprite.y);

        this.moonTween = this.scene.tweens.add({
            targets: sprite,
            y: -350,
            duration: this.dayLength,
            onComplete: () => { this.moonset(sprite) },
            onCompleteScope: this
        });
    }

    moonset(sprite){        
        sprite.setPosition(this.objectSettingPositionX, sprite.y);

        this.moonTween = this.scene.tweens.add({
            targets: sprite,
            y: this.sceneheight,
            duration: this.dayLength,
            onComplete: () => { this.moonrise(sprite) },
            onCompleteScope: this
        });
    }

    tweenTint(spriteToTween, startColor, endColor, duration) {

        let colorBlend = {step: 0};

        const tween = this.scene.tweens.addCounter({
            from: 0,
            to: 100,
            ease: 'Linear',
            duration: duration,
            onUpdate: () => {
                const tint = this.getTintColor(tween, startColor, endColor);
                //console.log(tint);
                spriteToTween.setTint(tint);
            },
            onUpdateScope: this
        });   
    }

    getTintColor(tween, start, end){
        var tint = Phaser.Display.Color.Interpolate.ColorWithColor(
            start,
            end,
            100,
            tween.getValue()
        );

        return Phaser.Display.Color.ObjectToColor(tint).color;
    }

}

export default DayCycle;